// Copyright (c) Docugami, Inc. All rights reserved.**/

import { DgColoredButton, DgGreenColoredButtonProps } from "components/common/DgCommonStyledComponents";
import { dgFontFamily } from "components/common/Fonts";
import { useRepublishDocumentsCommand } from "hooks/WorkPathCommands";
import styled from "styled-components";
import { RepublishDocumentsModal } from "./WorkPathCommandComponents";

const StyledButton = styled(DgColoredButton)`
    height: 32px;
    font-weight: 600;
    font-family: ${dgFontFamily};
    font-size: 14px;
    padding: 0 8px;
`;

export const RepublishButton = () => {

    const command = useRepublishDocumentsCommand();

    return (
        command.isVisible ?
            <>
                <RepublishDocumentsModal command={command} />
                <StyledButton controlButtonProps={DgGreenColoredButtonProps} onClick={command.onClick}>
                    {command.name}
                </StyledButton>
            </>
            :
            null
    )

}
